//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { clarityEvent } from "~/services/util";

export default {
  props: {
    data: {
      required: true,
    },
  },
  computed: {
    useLightTheme() {
      if (this.data.use_light_theme === true) return true;
      else return false;
    },
    url() {
      return "/order/new/compliance-guard";
    },
  },
  methods: {
    registerEventAndGo(url) {
      clarityEvent("Product Page > CG section");
      if (!this.data.is_external_link) this.$router.push(url);
      else window.open(url);
    },
  },
};
